/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Term/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Term({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/New/Confirm/Content/Referral/Value/Search/Patient/Term"
  
}) {
let patientSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'patient_search',
path: 'term',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Term.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="patient_search.term"
 value={patientSearchTermValueData}
 onChange={onChange}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}